import { useEffect, useState } from "react";
import { Bot, RefreshCw, ShieldAlert } from "lucide-react";
import { api, fmtDate } from "@/lib/api";
import { Button } from "@/components/ui/button";

const COULEUR = {
  GET: "bg-slate-100 text-slate-600 border-slate-200",
  POST: "bg-blue-50 text-blue-700 border-blue-200",
  PUT: "bg-blue-50 text-blue-700 border-blue-200",
  PATCH: "bg-blue-50 text-blue-700 border-blue-200",
  DELETE: "bg-red-50 text-red-700 border-red-200",
};

/** Audit des appels effectués par Claude via le serveur MCP (clé de service). */
export const JournalMCP = () => {
  const [data, setData] = useState(null);

  const load = () => api.get("/admin/mcp/journal", { params: { limite: 100 } }).then((r) => setData(r.data));

  useEffect(() => {
    load();
  }, []);

  if (!data) return null;

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5 space-y-4" data-testid="journal-mcp">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="bk-label flex items-center gap-2">
          <Bot size={13} /> Claude / MCP — {data.total} appel(s)
        </div>
        <Button data-testid="journal-mcp-refresh" variant="outline" size="sm" onClick={load}>
          <RefreshCw size={13} className="mr-1" /> Actualiser
        </Button>
      </div>

      {!data.cle_configuree && (
        <div className="flex items-start gap-2 rounded-lg border border-amber-300 bg-amber-50/60 px-3 py-2 text-xs text-amber-800" data-testid="journal-mcp-sans-cle">
          <ShieldAlert size={14} className="mt-0.5 shrink-0" />
          Aucune clé de service configurée sur cet environnement : le serveur MCP recevra une erreur 401.
          Ajoutez la variable <span className="font-mono-bk">MCP_API_KEY</span> puis redéployez.
        </div>
      )}

      <p className="text-xs text-slate-500">
        Chaque action de Claude sur BKPROD est enregistrée ici : méthode, route, outil appelé et adresse IP.
      </p>

      <div className="space-y-1 max-h-80 overflow-y-auto">
        {data.appels.map((a) => (
          <div key={a.id} data-testid={`journal-mcp-ligne-${a.id}`} className="flex flex-wrap items-center gap-2 border-b border-slate-100 pb-1.5 text-xs">
            <span className={`px-1.5 py-0.5 rounded border font-mono-bk ${COULEUR[a.methode] || COULEUR.GET}`}>{a.methode}</span>
            <span className="font-mono-bk text-slate-700">{a.chemin}</span>
            {a.outil && <span className="text-[#005CFF] font-semibold">{a.outil}</span>}
            <span className="text-slate-400 ml-auto">
              {a.ip} · {fmtDate(a.created_at)}
            </span>
          </div>
        ))}
        {data.appels.length === 0 && (
          <p className="text-xs text-slate-500" data-testid="journal-mcp-vide">
            Aucun appel pour le moment. Configurez le serveur MCP sur votre Mac (voir mcp/README.md).
          </p>
        )}
      </div>
    </div>
  );
};

export default JournalMCP;
